import { render } from "./B2bFiltersSalesReport.vue?vue&type=template&id=2461fccd&scoped=true&lang=pug"
import script from "./B2bFiltersSalesReport.vue?vue&type=script&lang=js"
export * from "./B2bFiltersSalesReport.vue?vue&type=script&lang=js"

import "./B2bFiltersSalesReport.vue?vue&type=style&index=0&id=2461fccd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2461fccd"]])

export default __exports__